export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Vibrant%20lifestyle%20product%20collage%20with%20fashion%20sneakers%20designer%20bags%20premium%20accessories%20and%20trendy%20clothing%20items%20artistically%20arranged%20on%20warm%20cream%20surface%2C%20soft%20golden%20hour%20sunlight%20streaming%20from%20window%2C%20modern%20boutique%20aesthetic%2C%20editorial%20product%20photography%2C%20clean%20bright%20composition%2C%20inviting%20atmosphere%2C%20diverse%20textures%20and%20materials%2C%20warm%20sand%20and%20terracotta%20tones%2C%20elegant%20curated%20display%2C%20no%20text%20no%20labels&width=1600&height=900&seq=hero-vigorbuy-fresh-11&orientation=landscape)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500"></span>
          <span className="text-xs md:text-sm text-background-50 font-medium">Updated 2026 Resources</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          The Ultimate Vigorbuy<br className="hidden sm:block" /> Spreadsheet Resource Hub
        </h1>

        <p className="text-base md:text-lg text-background-50/85 max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover updated Vigorbuy spreadsheets, verified product lists, category guides, 
          QC photo resources, and expert shopping tutorials designed to help international 
          buyers find products faster and shop smarter.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            Vigorbuy Spreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold rounded-full bg-background-50 text-foreground-900 hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-cart-line"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          <span className="flex items-center gap-1.5 text-xs text-background-50/75 whitespace-nowrap">
            <i className="ri-check-line text-accent-400 text-sm"></i> Updated Resources
          </span>
          <span className="flex items-center gap-1.5 text-xs text-background-50/75 whitespace-nowrap">
            <i className="ri-check-line text-accent-400 text-sm"></i> Beginner Friendly
          </span>
          <span className="flex items-center gap-1.5 text-xs text-background-50/75 whitespace-nowrap">
            <i className="ri-check-line text-accent-400 text-sm"></i> Shopping Guides
          </span>
          <span className="flex items-center gap-1.5 text-xs text-background-50/75 whitespace-nowrap">
            <i className="ri-check-line text-accent-400 text-sm"></i> Safety Education
          </span>
        </div>
      </div>
    </section>
  );
}